import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Client } from "../domain/client";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";

@Injectable({
    providedIn: 'root',
})
export class ClientService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/client`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    /**
     * 
     * @param text Client Code or Client Name
     * @returns 
     */
    getClientList(text: string) {
        let params = new HttpParams();
        if (text) {
            params = params.append('filter', `${text}`);
        }
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/elims`, this.generateHeaderWithParameters(params)).pipe(
            catchError(this.handleError<any>('getClientList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Client[]) => {
                return response.map((item: Client) => {
                    return Client.mapFromJSON(item);
                });
            }));
    }
}